<!--
 * @Description: 帐户安全
 * @Author: xu wei
 * @Date: 2020-03-05 14:42:45
 * @LastEditTime: 2020-06-17 16:24:58
 * @LastEditors: gao shuai
 -->
<template>
  <div class="home">
    <div class="person_tit">帐户安全</div>
    <div class="ipbox">
      <el-checkbox v-model="checked">限制登录账户的计算机IP</el-checkbox>
      <p class="tip">请确保你的计算机在公网拥有固定输入的IP，而不是动态分配的，如ADSL</p>
      <div class="iplistBox">
        <div class="tit">授权IP :</div>
        <div class="addBox">
          <el-tag :key="tag" v-for="(tag, i) in ipList" closable :disable-transitions="false" @close="handleClose(tag,i)">
            {{tag}}
          </el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
          </el-input>
          <el-button class="button-new-tag" size="small" @click="showInput">+ 增加授权ip</el-button>
        </div>
      </div>
      <p class="btnBox">
        <el-button size="small" type="primary" @click="dialog.show= true">确定保存</el-button>
      </p>
    </div>
    <!-- 二级密码的确认 -->
    <el-dialog title="提示" :visible.sync="dialog.show" @close="dialog.secondPassword=''" custom-class="gs_dialog" width="400px">
      <div class="passwordBox">
        <span class="tit">二级密码：</span>
        <div class="inputBox">
          <el-input style="width:220px;" type="password" size="small" v-model="dialog.secondPassword" placeholder="请输入二级密码"></el-input>
        </div>
      </div>
      <p class="tc pdb10">
        <el-button size="small" type="primary" @click="sureSeeaccount">确定</el-button>
        <el-button size="small" type="info" @click="dialog.show=false">取消</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
      ipList: [],
      inputVisible: false,
      inputValue: '',
      dialog: {
        show: false,
        secondPassword: ''
      }
    };
  },
  methods: {
    // 获取商户安全IP
    getSafeIp() {
      this.$api.personCenter
        .getsafeIp()
        .then((data) => {
          if (data.status === 200) {
            this.checked = data.data.isOpenSecurityLimit;
            this.ipList = data.data.securityIp;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 输入二级密码后确认
    sureSeeaccount() {
      if (this.dialog.secondPassword === '') {
        this.$messageError('请输入二级密码！');
        return;
      }
      this.$api.personCenter
        .setsafeIp({
          tenantSafetyIP: {
            isOpenSecurityLimit: this.checked,
            securityIp: this.ipList
          },
          password: this.dialog.secondPassword
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('设置成功！');
            this.dialog.show = false;
            this.getSafeIp();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 一篮子增加IP
    handleClose(tag, index) {
      this.ipList.splice(index, 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ipList.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  },
  created() {
    this.getSafeIp();
  }
};
</script>

<style lang="scss" scoped>
.ipbox {
  background: #fff;
  padding: 0 30px 20px;
  .tip {
    font-size: 15px;
    color: #333;
    margin: 10px 0;
  }
  .iplistBox {
    display: flex;
    flex-flow: row nowrap;
    .tit {
      width: 120px;
      padding-left: 20px;
      line-height: 32px;
    }
    .addBox {
      width: 150px;
      &::v-deep .el-tag {
        position: relative;
        display: block;
        margin-bottom: 10px;
        padding-right: 30px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .el-icon-close {
          right: 5px;
          top: 8px;
          position: absolute;
        }
      }
      .input-new-tag {
        margin-bottom: 10px;
      }
    }
  }
  .btnBox {
    padding-left: 140px;
    margin-top: 20px;
  }
}
.person_tit {
  color: #3c8dbc;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 15px;
  background: #fff;
  padding-left: 20px;
}
.passwordBox {
  padding-left: 20px;
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 16px;
  .tit {
    display: block;
    width: 100px;
    height: 32px;
    line-height: 32px;
  }
}
</style>
